import { render, staticRenderFns } from "./AssignMenuPermissions.vue?vue&type=template&id=13408ad4&scoped=true"
import script from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
export * from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignMenuPermissions.vue?vue&type=style&index=0&id=13408ad4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13408ad4",
  null
  
)

export default component.exports